const kebabCase = (text = '') => {
  return text
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map((x) => x.toLowerCase())
    .join('-');
};

window.storeTheme = window.storeTheme || ({} as StoreTheme);

Object.assign(window.storeTheme, {
  helpers: Object.assign(window.storeTheme.helpers || {}, {
    text: {
      kebabCase,
    },
  }),
});

export default {};
